import CheckmarkCircle from 'icon/checkmark_circle.svg';
import { useAtomValue } from 'jotai';
import { $ToastAtom } from '~/atoms/simple-toast';
import { FC } from 'react';

import './style.scss';

const toastIconMap = {
  success: CheckmarkCircle,
  default: () => <></>,
};

export type ToastIconType = keyof typeof toastIconMap;

export const ToastIcon: FC = () => {
  const { iconStatus = 'default' } = useAtomValue($ToastAtom);

  const ToastIconComponent = toastIconMap[iconStatus];

  return <ToastIconComponent className="toast-icon" />;
};
